module.exports = __webpack_public_path__ + "img/404.8774733.gif";